import type { AdvanceSearchLoginModalData } from "../../components/modal/advance-filter-modal";
console.log("sso url", import.meta.env.PUBLIC_SSO_BASE_URL);
export const getAuthModalData = (type: string): AdvanceSearchLoginModalData => {
  const baseData = {
    title: {
      simpleText: "Discover your perfect",
      coloredText: "",
    },
    button2: {
      text: "Login",
      link: `${import.meta.env.PUBLIC_SSO_BASE_URL}/?redirect_uri=${encodeURIComponent(window.location.origin)}`,
    },
    image: "/images/modal/laptop snippet.png",
  };

  switch (type) {
    case "courses":
    case "course":
      return {
        ...baseData,
        title: {
          simpleText:
            "Discover your perfect course match from 300,000+ options with our",
          coloredText: "Advanced Filters!",
        },
      };
    case "scholarships":
    case "scholarship":
      return {
        ...baseData,
        title: {
          simpleText:
            "Discover your perfect scholarship match from 6000+ options with our",
          coloredText: "Advanced Filters!",
        },
      };
    case "universities":
    case "institute":
      return {
        ...baseData,
        title: {
          simpleText:
            "Discover your perfect university or institute match from 3,000+ options with our",
          coloredText: "Advanced Filters!",
        },
      };
    case "english courses":
      return {
        ...baseData,
        title: {
          simpleText:
            "Discover your perfect english courses match from 10,000+ options with our",
          coloredText: "Advanced Filters!",
        },
      };
    default:
      return baseData;
  }
};


export const advanceSearchLoginModaldata: AdvanceSearchLoginModalData = {
  title: {
    simpleText: "Discover your perfect course from 300k options with our",
    coloredText: "Advanced Filters!",
  },
  button2: {
    text: "Login",
    link: `${import.meta.env.PUBLIC_SSO_BASE_URL}/?redirect_uri=${encodeURIComponent(window.location.origin)}`,
  },
  image: "/images/modal/laptop snippet.png",
};

